(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-aav-size-guide]');
    if (!root) return;

    const input = root.querySelector('[data-aav-size-search-input]');
    const clearBtn = root.querySelector('[data-aav-size-search-clear]');
    const emptyMsg = root.querySelector('[data-aav-size-search-empty]');
    const rows = Array.from(root.querySelectorAll('[data-aav-size-row]'));
    const texts = Array.from(root.querySelectorAll('[data-aav-breeds-text]'));

    if (!input || !rows.length) return;

    texts.forEach((el) => {
      if (!el.dataset.aavOriginalHtml) {
        el.dataset.aavOriginalHtml = el.innerHTML;
      }
    });

    const norm = (s) => (s || '').toString().trim().toLowerCase();

    // Defined in assets/breed-aliases.js, which the layout loads deferred; this runs on
    // DOMContentLoaded, by which time every deferred script has executed. Guarded anyway, because
    // a missing alias table should cost the colloquial names and nothing else.
    const aliasTargets = (value) =>
      typeof window.WOOPF_BREED_ALIAS_TARGETS === 'function'
        ? window.WOOPF_BREED_ALIAS_TARGETS(value)
        : [];

    function restoreAll() {
      texts.forEach((el) => {
        const orig = el.dataset.aavOriginalHtml;
        if (typeof orig === 'string') el.innerHTML = orig;
      });
    }

    function highlightInElement(el, q) {
      if (!q) return;

      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      const nodes = [];

      while (walker.nextNode()) {
        nodes.push(walker.currentNode);
      }

      nodes.forEach((node) => {
        const val = node.nodeValue;
        if (!val) return;

        const lower = val.toLowerCase();
        if (!lower.includes(q)) return;

        const frag = document.createDocumentFragment();
        let start = 0;

        while (true) {
          const i = lower.indexOf(q, start);
          if (i === -1) break;

          if (i > start) {
            frag.appendChild(document.createTextNode(val.slice(start, i)));
          }

          const mark = document.createElement('mark');
          mark.className = 'aav-hl';
          mark.textContent = val.slice(i, i + q.length);
          frag.appendChild(mark);

          start = i + q.length;
        }

        if (start < val.length) {
          frag.appendChild(document.createTextNode(val.slice(start)));
        }

        node.parentNode.replaceChild(frag, node);
      });
    }

    function rowText(row) {
      const blocks = row.querySelectorAll('[data-aav-breeds-text]');
      let s = '';

      blocks.forEach((b) => {
        s += ' ' + (b.textContent || '');
      });

      return norm(s);
    }

    function openRowMore(row) {
      const toggle = row.querySelector('.aav-size-row__more-toggle');
      if (toggle) toggle.checked = true;
    }

    function closeRowMore(row) {
      const toggle = row.querySelector('.aav-size-row__more-toggle');
      if (toggle) toggle.checked = false;
    }

    function applyFilter() {
      const q = norm(input.value);

      clearBtn.style.display = q ? 'flex' : 'none';

      restoreAll();

      let visibleCount = 0;

      rows.forEach((row) => {
        if (!q) {
          row.style.display = '';
          closeRowMore(row);
          visibleCount++;
          return;
        }

        const t = rowText(row);

        // GAP3-11 (#226): an Australian types Cavoodle, Groodle, Blue Heeler or Staffy, and the
        // rows hold American Kennel Club names. The query is widened rather than replaced, so a
        // search that already worked keeps every row it used to find.
        const terms = [q, ...aliasTargets(input.value).map(norm)];
        const hit = terms.find((term) => term && t.includes(term));

        row.style.display = hit ? '' : 'none';

        if (hit) {
          visibleCount++;
          openRowMore(row);

          row.querySelectorAll('[data-aav-breeds-text]').forEach((el) => {
            highlightInElement(el, hit);
          });
        }
      });

      emptyMsg.style.display = !q || visibleCount > 0 ? 'none' : 'block';
    }

    input.addEventListener('input', applyFilter);

    clearBtn.addEventListener('click', () => {
      input.value = '';
      input.focus();
      applyFilter();
    });

    applyFilter();
  });
})();
